<template>
  <div id="Home">
    <Layout>
      <hl-header
        @collapsedSider="collapsedSider"
        :isCollapsed="isCollapsed"
        @downMenuClick="downMenuClick"
      ></hl-header>
      <Layout class="ivu-layout-has-sider">
        <hl-sider
          :activeName="activeName"
          :openNames="openNames"
          :menuList="menuList"
          @onSelectMenu="onSelectMenu"
          ref="siderRef"
        ></hl-sider>
        <Layout class="main-content-layout">
          <!-- 面包屑导航 -->
          <div class="breadcrumb-container">
          <Breadcrumb :style="{ margin: '12px 0' }">
            <BreadcrumbItem v-for="item in breadcrumbList" :key="item">
              {{ item }}
            </BreadcrumbItem>
          </Breadcrumb>
          </div>
          <!-- 路由占位符 -->
          <div class="main-content-wrapper">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
          </div>
        </Layout>
      </Layout>
    </Layout>
    <!-- 修改密码 -->
    <Modal
      v-model="updatePsModal"
      title="修改密码"
      @on-cancel="updatePsCancel('formValidate')"
    >
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="旧密码" prop="oldPs">
          <Input v-model="formValidate.oldPs" placeholder="旧密码" />
        </FormItem>
        <FormItem label="新密码" prop="newPs">
          <Input v-model="formValidate.newPs" placeholder="新密码" />
        </FormItem>
        <FormItem label="新密码" prop="newPsAgain">
          <Input v-model="formValidate.newPsAgain" placeholder="确认新密码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="updatePsCancel('formValidate')">取消</Button>
        <Button type="primary" @click="updatePsOk('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { usersUpdatePs } from '@/api/user'
import hlHeader from './hl-Header.vue'
import hlSider from './hl-Siders.vue'
export default {
  name: 'Home',
  components: {
    hlHeader,
    hlSider,
  },
  data() {
    return {
      menuList: [
        {
          id: 1,
          name: "首页",
          path: "welcome",
          icon: "md-home",
          children: [],
        },
        {
          id: 10,
          name: "数据统计",
          path: "statistics",
          icon: "ios-stats",
          children: [],
        },
        {
          id: 11,
          name: "系统监控",
          path: "monitor",
          icon: "ios-pulse",
          children: [],
        },
        {
          id: 12,
          name: "业务管理",
          path: "business",
          icon: "md-briefcase",
          children: [
            { id: 121, path: "order", name: "订单管理", icon: "ios-document" },
            { id: 122, path: "foodorder", name: "商品订单", icon: "ios-cart" },
            { id: 128, path: "shop-dine-qrcode", name: "堂食桌码", icon: "ios-qr-scanner" },
            { id: 123, path: "customer", name: "客户管理", icon: "ios-people" },
            { id: 124, path: "car", name: "车辆管理", icon: "ios-car" },
            { id: 126, path: "ride-billing", name: "用车费用管理", icon: "ios-calculator" },
            { id: 125, path: "carRealtime", name: "车辆监控", icon: "ios-navigate" },
          ],
        },
        {
          id: 17,
          name: "营销管理",
          path: "marketing",
          icon: "ios-megaphone-outline",
          children: [
            { id: 171, path: "coupon-manage", name: "优惠券管理", icon: "ios-pricetag" },
            { id: 172, path: "coupon-issued", name: "已发放优惠券", icon: "ios-paper-outline" },
          ],
        },
        {
          id: 13,
          name: "商品管理",
          path: "goods",
          icon: "ios-cube",
          children: [],
        },
        {
          id: 14,
          name: "服务管理",
          icon: "ios-construct",
          children: [
            { id: 141, path: "complaint", name: "投诉建议", icon: "ios-chatbubbles" },
            { id: 142, path: "rescue", name: "一键救援", icon: "ios-warning" },
          ],
        },
        {
          id: 15,
          name: "区域管理",
          path: "area",
          icon: "ios-pin",
          children: [],
        },
        {
          id: 2,
          name: "系统管理",
          icon: "ios-settings",
          children: [
            { id: 21, path: "users", name: "用户管理", icon: "ios-person" },
            { id: 22, path: "roles", name: "角色管理", icon: "ios-contacts" },
            { id: 23, path: "permits", name: "权限管理", icon: "ios-key" },
            { id: 24, path: "operation-log", name: "操作日志", icon: "ios-paper" },
          ],
        },
        {
          id: 16,
          name: "消息中心",
          path: "notifications",
          icon: "ios-notifications",
          children: [],
        },
        {
          id: 5,
          name: "其他设置",
          icon: "md-more",
          children: [
            { id: 51, path: "other", name: "客服管理", icon: "ios-call" },
            { id: 52, path: "lang", name: "国际化", icon: "ios-globe" },
          ],
        },
      ],
      activeName: 'welcome',
      isCollapsed: false,
      updatePsModal: false,
      formValidate: {
        oldPs: '',
        newPs: '',
        newPsAgain: '',
      },
      ruleValidate: {
        oldPs: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPs: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        newPsAgain: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.formValidate.newPs) {
                callback(new Error('确认密码和新密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      loading: true,
      openNames: [],
      breadcrumbList: [],
    }
  },

  methods: {
    /** 数据库菜单为扁平结构（车辆管理、订单列表等），注入「用车费用管理」 */
    injectRideBillingMenu(list) {
      if (!Array.isArray(list) || !list.length) return list
      const has = list.some(
        (item) =>
          item.path === 'ride-billing' ||
          (item.children &&
            item.children.some((c) => c.path === 'ride-billing'))
      )
      if (has) return list

      const entry = {
        id: 126,
        name: '用车费用管理',
        path: 'ride-billing',
        icon: 'ios-calculator',
        children: [],
        mark: '用车费用管理',
        sort: 2,
        level: 0,
      }

      const carIdx = list.findIndex(
        (item) =>
          item.path === 'car' ||
          (item.children && item.children.some((c) => c.path === 'car'))
      )
      if (carIdx >= 0) {
        const next = [...list]
        next.splice(carIdx + 1, 0, entry)
        return next
      }
      return [...list, entry]
    },
    shopDineMenuEntry() {
      return {
        id: 128,
        name: '堂食桌码',
        path: 'shop-dine-qrcode',
        icon: 'ios-qr-scanner',
        children: [],
        mark: '堂食桌码',
        sort: 2,
        level: 0,
      }
    },
    menuHasShopDine(list) {
      if (!Array.isArray(list)) return false
      return list.some(
        (item) =>
          item.path === 'shop-dine-qrcode' ||
          (item.children && item.children.some((c) => c.path === 'shop-dine-qrcode'))
      )
    },
    /** 注入「堂食桌码」：优先挂在「业务管理」下，否则插在商品订单/商品管理附近 */
    injectShopDineMenu(list) {
      if (!Array.isArray(list) || !list.length) return list
      if (this.menuHasShopDine(list)) return list

      const entry = this.shopDineMenuEntry()
      const next = list.map((item) => ({
        ...item,
        children: Array.isArray(item.children) ? [...item.children] : [],
      }))

      const business = next.find(
        (item) =>
          item.path === 'business' ||
          item.name === '业务管理' ||
          (item.children &&
            item.children.some((c) =>
              ['foodorder', 'order', 'goods'].includes(c.path)
            ))
      )
      if (business) {
        if (!Array.isArray(business.children)) business.children = []
        const foodIdx = business.children.findIndex((c) =>
          ['foodorder', 'goods'].includes(c.path)
        )
        if (foodIdx >= 0) {
          business.children.splice(foodIdx + 1, 0, { ...entry, level: 1 })
        } else {
          business.children.push({ ...entry, level: 1 })
        }
        return next
      }

      const flatIdx = next.findIndex((item) =>
        ['foodorder', 'goods'].includes(item.path)
      )
      if (flatIdx >= 0) {
        next.splice(flatIdx + 1, 0, entry)
        return next
      }
      return [...next, entry]
    },
    getMenus() {
      try {
        const menus = this.$store.getters.menus
        if (menus) {
          const parsedMenus = JSON.parse(menus)
          if (parsedMenus && parsedMenus.length > 0) {
            this.menuList = this.injectShopDineMenu(
              this.injectRideBillingMenu(parsedMenus)
            )
            return
          }
        }
      } catch (e) {
        console.warn('使用默认菜单配置', e)
      }
      // 无缓存菜单：确保默认 menuList 也含堂食桌码
      if (!this.menuHasShopDine(this.menuList)) {
        this.menuList = this.injectShopDineMenu(this.menuList)
      }
    },
    // 获取当前选中菜单，二级菜单展开
    getActive() {
      this.activeName = this.$route.name
      const parentPath = this.findParentMenuPath(this.menuList, this.$route.name)
      this.openNames = parentPath ? [parentPath] : []
    },
    findParentMenuPath(list, routeName) {
      if (!Array.isArray(list) || !routeName) return null
      for (const item of list) {
        const children = item.children || []
        if (children.some((c) => c.path === routeName)) {
          return item.path || null
        }
      }
      return null
    },
    onSelectMenu(val) {
      if (this.$route.name === val) return
      this.$router.push({ name: val }).catch(() => {})
      this.activeName = val
      this.breadcrumbChange()
    },
    collapsedSider() {
      this.$refs.siderRef.toggleCollapse()
      this.isCollapsed = !this.isCollapsed
    },
    downMenuClick(val) {
      if (val === 'logOut') {
        this.$router.push({ name: 'login' }, () => {
          this.$Message.success('退出成功')
          this.$store.commit('removeToken')
        })
      } else if (val === 'updatePs') {
        this.updatePsModal = true
      }
    },
    updatePsOk(name) {
      this.$refs[name].validate((valid) => {
        if (!valid) return
        usersUpdatePs(this.formValidate)
          .then((res) => {
            if (res.data.code === 200) {
              this.$Message.success('密码修改成功')
              setTimeout(() => {
                this.$router.push({ name: 'login' }, () => {
                  this.$store.commit('removeToken')
                })
              }, 1000)
            } else {
              this.$Message.error(res.data.msg)
            }
          })
          .catch((err) => {
            this.$Message.error(err)
          })
      })
    },
    updatePsCancel(name) {
      this.formValidate = {
        oldPs: '',
        newPs: '',
        newPsAgain: '',
      }
      this.$refs[name].resetFields()
      this.updatePsModal = false
    },
    breadcrumbChange() {
      setTimeout(() => {
        const path = this.$route.path
        const pathList = path.split('/')
        pathList.shift()
        this.breadcrumbList = this.getBreadcrumbList(pathList, this.menuList)
      }, 100)
    },
    /** 在整棵菜单里按 path 找一级或二级项，用于面包屑（避免子菜单只显示英文 path） */
    findMenuLabelsForSegment(segment, list) {
      if (!segment || !Array.isArray(list)) return null
      for (const item of list) {
        if (item.path === segment) return [item.name]
        const children = item.children || []
        for (const c of children) {
          if (c.path === segment) return [item.name, c.name]
        }
      }
      return null
    },
    getBreadcrumbList(pathList, list) {
      const arr = []
      let ls = list
      pathList.filter(Boolean).forEach((child) => {
        const level = ls.find((item) => item.path === child)
        if (level) {
          arr.push(level.name)
          ls = level.children || []
        } else {
          const deep = this.findMenuLabelsForSegment(child, list)
          if (deep && deep.length) {
            arr.push(...deep)
          } else {
            const title = this.$route && this.$route.meta && this.$route.meta.title
            arr.push(title || child)
          }
          ls = []
        }
      })
      return arr
    },
  },
  watch: {
    $route() {
      this.getActive()
      this.breadcrumbChange()
    },
  },
  created() {
    this.getMenus()
    this.getActive()
    this.breadcrumbChange()
  },
}
</script>
<style lang="less">
#Home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  
  .ivu-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    // 外层Layout（包含Header和内容区域）
    &:first-child {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    
    // 内层Layout（包含Sider和主内容）
    &.ivu-layout-has-sider {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
      min-height: 0; // 重要：允许flex子元素缩小
    }
    
    .ivu-layout-header {
      padding: 0;
      flex-shrink: 0; // 头部不收缩
      .log_out {
        margin: 0px 20px;
        color: #fff;
        float: right;
        cursor: pointer;
        .ivu-icon {
          vertical-align: middle;
        }
      }
    }
    
    .ivu-layout-content {
      height: 100%;
      padding: 24px;
      background-color: #fff;
    }
    
    .ivu-layout-sider {
      background: #515a6e !important;
      flex-shrink: 0; // 侧边栏不收缩
      overflow-y: auto; // 侧边栏内容可滚动
    }
  }
  
  // 主内容区域布局
  .main-content-layout {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 12px 24px;
    min-height: 0; // 重要：允许flex子元素缩小
    overflow: hidden;
    }
    
  // 面包屑容器（固定，不滚动）
  .breadcrumb-container {
    flex-shrink: 0;
    padding: 0;
    }
    
  // 主内容包装器（可滚动区域）
  .main-content-wrapper {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0; // 重要：允许flex子元素缩小
    padding: 0;
    background-color: transparent;
    
    // 自定义滚动条样式（可选）
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
      }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
      
      &:hover {
        background: #a8a8a8;
    }
  }
  }
  
  .layout-logo {
    font-size: 20px;
    text-align: center;
    width: 200px;
    height: 100%;
    color: #fff;
    background: #5b6270;
    border-radius: 3px;
    float: left;
  }
  
  .layout-nav {
    width: 420px;
    margin: 0 auto;
    /* margin-right: 20px; */
  }
}
</style>
